import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-app-culture-list',
  templateUrl: './culture-list.component.html',
  styleUrls: ['./culture-list.component.scss']
})
export class CultureListComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
